import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { PromoContent } from '@cinemark/content-api-client';

type PromotionalVideoEmbeddedProps = {
  dataLinkCategory: string;
  dataLinkName?: string;
  promoContent: PromoContent;
};

export const PromotionalVideoEmbedded = ({ dataLinkCategory, dataLinkName, promoContent }: PromotionalVideoEmbeddedProps): React.JSX.Element | null => {
  const { trackClick } = useDataAnalytics();

  if (!promoContent?.url) {
    return null;
  }

  return (
    <div className="w-full"
      onClick={() => trackClick({
        linkCategory: dataLinkCategory,
        linkName: dataLinkName || `Promotional Video Click ${promoContent.promoTitle}`,
      })}
    >
      <div className="w-full aspect-video">
        <iframe allowFullScreen
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          className="w-full h-full rounded-lg"
          sandbox="allow-scripts allow-same-origin allow-presentation"
          src={promoContent.url}
          title={promoContent.promoTitle || 'External Video'}
        />
      </div>
    </div>
  );
};
